import api from './api';

/** KPI della Dashboard Backoffice. Per la definizione esatta di ogni
 * contatore vedi il docstring di ``backend/admin/dashboard_router.py``. */
export interface AdminDashboardKpi {
  generatedAt: string;
  /** Giorno di riferimento di ``ordiniOggi`` (AAAA-MM-GG, fuso Europe/Rome). */
  giorno: string;
  /** Mese di riferimento di ``ordiniMese`` (AAAA-MM). */
  mese: string;
  ordiniOggi: number;
  ordiniMese: number;
  /** Clienti distinti con un'azione negli ultimi ``onlineFinestraMinuti``.
   * Unità di conteggio l'azienda, non l'utente. */
  onlineOra: number;
  /** Finestra configurata in Admin → Configurazione (default 15). */
  onlineFinestraMinuti: number;
  /** Registrazioni spontanee in attesa di approvazione. */
  clientiDaAttivare: number;
  rmaPendenti: number;
  alertStock: number;
  segnalazioni: number;
}

export async function fetchAdminDashboardKpi(): Promise<AdminDashboardKpi> {
  const { data } = await api.get<AdminDashboardKpi>('/api/admin/dashboard/kpi');
  return data;
}
